import { FleekError } from './FleekError';

type FunctionFields = {
  id?: string;
  name?: string;
};

type FleekFunctionNotFoundErrorOptions = {
  function?: FunctionFields;
};

export class FleekFunctionNotFoundError extends FleekError<FleekFunctionNotFoundErrorOptions> {
  public name = 'FleekFunctionNotFoundError';

  toString = () => {
    if (this.data.function?.name) {
      return `Function ${this.data.function.name} not found.`;
    }

    return `Function not found.`;
  };
}
